// extracted by mini-css-extract-plugin
export var banner = "_no-0";
export var settingRow = "_no-2";
export var titleIcon = "_no-1";